import { Card, Loader } from '@lifebit-ai/lds'
import React from 'react'

import FormSubmissionPreview from 'modules/resultsV2/components/FormSubmissionPreview/FormSubmissionPreview'
import type { ResultFormSubmission } from 'services/results/types'
import { CardBody } from 'ui/card/card.styles'

import * as formCardStyles from './DataAccessRequestDetailsFormCard.styles'
import {
  DataAccessRequestDetailsMetadata,
  type DataAccessRequestDetailsMetadataProps
} from './DataAccessRequestDetailsMetadata'

export const DATA_ACCESS_REQUEST_METADATA_LOADER_TEST_ID = 'data-access-request-metadata-loader'
export const DATA_ACCESS_REQUEST_METADATA_ERROR_TEST_ID = 'data-access-request-metadata-error'

interface DataAccessRequestDetailsFormCardProps {
  formSubmission: ResultFormSubmission
  isMetadataError?: boolean
  isMetadataLoading?: boolean
  metadataProps?: DataAccessRequestDetailsMetadataProps
  onViewForm: () => void
  title?: string
  viewActionTestId?: string
}

export const DataAccessRequestDetailsFormCard = ({
  formSubmission,
  isMetadataError = false,
  isMetadataLoading = false,
  metadataProps,
  onViewForm,
  title,
  viewActionTestId
}: DataAccessRequestDetailsFormCardProps): JSX.Element => {
  const shouldDisplayFormBorder = metadataProps !== undefined || isMetadataLoading || isMetadataError

  return (
    <Card>
      <CardBody>
        <formCardStyles.StorageContentList $displayBorder={shouldDisplayFormBorder}>
          <FormSubmissionPreview
            formSubmission={formSubmission}
            hasBorder={false}
            onViewForm={onViewForm}
            title={title}
            viewActionTestId={viewActionTestId}
          />
        </formCardStyles.StorageContentList>
        {isMetadataLoading ? (
          <div data-testid={DATA_ACCESS_REQUEST_METADATA_LOADER_TEST_ID}>
            <Loader />
          </div>
        ) : null}
        {isMetadataError ? (
          <formCardStyles.MetadataErrorMessage data-testid={DATA_ACCESS_REQUEST_METADATA_ERROR_TEST_ID}>
            Couldn't load original request metadata.
          </formCardStyles.MetadataErrorMessage>
        ) : null}
        {metadataProps !== undefined ? <DataAccessRequestDetailsMetadata {...metadataProps} /> : null}
      </CardBody>
    </Card>
  )
}
